import classnames from "classnames";
import { inject } from "mobx-react";
import { ResponsiveImage } from "../components/ResponsiveImage.component";
import { useElementOnScreen } from "../lib/embed";
import { generateImageAssetSizes } from "@inferno/renderer-shared-core";
import { placeholderImage, EmbedLegacyProps } from "@ihr-radioedit/inferno-core";
import { RESPONSIVE_IMAGE } from "../ui/constants";
import "./Embed.style.scss";
import { EmbedLegacyItem } from "./EmbedLegacyItem.component";

let counter = 0;

export const EmbedLegacy = inject("store")((props: EmbedLegacyProps) => {
  if (!props.store) {
    return null;
  }

  const [containerRef, isViewable] = useElementOnScreen<HTMLDivElement>({
    rootMargin: "0px 0px 0px 0px",
    threshold: [0, 0.25, 0.5, 0.75, 1],
  });

  const placeholder = () => {
    const { srcset, sizes, placeholderSrcset } = generateImageAssetSizes(placeholderImage);
    return (
      <figure className="component-asset-placeholder">
        <section className="image-container">
          <ResponsiveImage
            src={placeholderImage}
            srcset={srcset}
            sizes={sizes}
            alt="placeholder image"
            placeholderSrcset={placeholderSrcset}
            initialWidth={RESPONSIVE_IMAGE.responsiveImageInitialWidth}
            initialHeight={RESPONSIVE_IMAGE.responsiveImageInitialHeight}
          />
        </section>
      </figure>
    );
  };

  const className = classnames("component-embed", { viewable: isViewable });
  return (
    <div className={className} ref={containerRef}>
      {isViewable ? <EmbedLegacyItem counter={++counter} {...props} /> : placeholder()}
    </div>
  );
});

export default EmbedLegacy;
